import { useParams, useNavigate, Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../services/translations";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./FacilityDetailPage.css";

const facilityData = {
  ot:       { key:"ot",       titleKey:"facilityOTFullTitle",        descKey:"facilityOTFullDesc",        img:"/1.png",  featureKeys:["facilityOTF1","facilityOTF2","facilityOTF3","facilityOTF4","facilityOTF5"] },
  consult:  { key:"consult",  titleKey:"facilityConsultFullTitle",   descKey:"facilityConsultFullDesc",   img:"/4.png",  featureKeys:["facilityConsultF1","facilityConsultF2","facilityConsultF3","facilityConsultF4"] },
  waiting:  { key:"waiting",  titleKey:"facilityWaitingFullTitle",   descKey:"facilityWaitingFullDesc",   img:"/3.png",  featureKeys:["facilityWaitingF1","facilityWaitingF2","facilityWaitingF3","facilityWaitingF4"] },
  emergency:{ key:"emergency",titleKey:"facilityEmergencyFullTitle", descKey:"facilityEmergencyFullDesc", img:"/5.png",  featureKeys:["facilityEmergencyF1","facilityEmergencyF2","facilityEmergencyF3","facilityEmergencyF4","facilityEmergencyF5"] },
  reception:{ key:"reception",titleKey:"facilityReceptionFullTitle", descKey:"facilityReceptionFullDesc", img:"/7f.png", featureKeys:["facilityReceptionF1","facilityReceptionF2","facilityReceptionF3","facilityReceptionF4"] },
  lab:      { key:"lab",      titleKey:"facilityLabFullTitle",       descKey:"facilityLabFullDesc",       img:"/8l.png", featureKeys:["facilityLabF1","facilityLabF2","facilityLabF3","facilityLabF4","facilityLabF5"] },
  pharmacy: { key:"pharmacy", titleKey:"facilityPharmacyFullTitle",  descKey:"facilityPharmacyFullDesc",  img:"/6p.png", featureKeys:["facilityPharmacyF1","facilityPharmacyF2","facilityPharmacyF3","facilityPharmacyF4"] },
  parking:  { key:"parking",  titleKey:"facilityParkingFullTitle",   descKey:"facilityParkingFullDesc",   img:"/9P.png", featureKeys:["facilityParkingF1","facilityParkingF2","facilityParkingF3","facilityParkingF4"] },
};

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const FacilityDetailPage = () => {
  const { facilityKey } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const facility = facilityData[facilityKey];

  if (!facility) {
    return (
      <div className="fdp-not-found">
        <h2>Facility not found</h2>
        <button className="fdp-back-btn" onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const otherFacilities = Object.values(facilityData).filter((f) => f.key !== facilityKey).slice(0, 4);

  return (
    <div className="fdp-page nb-page-offset">
      <Navbar />
      {/* Hero */}
      <section className="fdp-hero" style={{backgroundImage: `url(${process.env.PUBLIC_URL}${facility.img})`}}>
        <div className="fdp-hero-overlay" />
        <div className="fdp-hero-content">
          <button className="fdp-back-btn" onClick={() => navigate(-1)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            {t("backToFacilities")}
          </button>
          <div className="fdp-eyebrow">{t("ourFacilitiesEyebrow")}</div>
          <h1 className="fdp-hero-title">{t(facility.titleKey)}</h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="fdp-main">
        <div className="fdp-main-inner">
          {/* Image Left */}
          <div className="fdp-img-col">
            <div className="fdp-img-frame">
              <img
                src={`${process.env.PUBLIC_URL}${facility.img}`}
                alt={t(facility.titleKey)}
                className="fdp-img"
              />
            </div>
            {/* Other Facilities */}
            <div className="fdp-other-card">
              <h3>{t("relatedFacilities")}</h3>
              <ul className="fdp-other-list">
                {otherFacilities.map((f) => (
                  <li key={f.key}>
                    <Link to={`/facilities/${f.key}`} className="fdp-other-link">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                        <polyline points="9 18 15 12 9 6" />
                      </svg>
                      {t(f.titleKey)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Content Right */}
          <div className="fdp-content-col">
            <div className="fdp-content-card">
              <h2 className="fdp-content-title">{t(facility.titleKey)}</h2>
              <p className="fdp-content-desc">{t(facility.descKey)}</p>

              <div className="fdp-features-section">
                <h3 className="fdp-features-title">{t("facilityFeatures")}</h3>
                <ul className="fdp-features-list">
                  {facility.featureKeys.map((fk, i) => (
                    <li key={i} className="fdp-feature-item">
                      <span className="fdp-feature-check"><CheckIcon /></span>
                      {t(fk)}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="fdp-cta-row">
                <Link to="/" className="fdp-book-btn">{t("bookAppointment")}</Link>
                <a href="tel:+919996504991" className="fdp-call-btn">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                  </svg>
                  +91 9996504991
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default FacilityDetailPage;
